<template>
  <el-dialog :title="title" :center="true" width="95%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :showClose="false"
  >
    <el-row style="position: fixed; z-index:999; background-color: white; width: 95%;">
      <el-col :span="18">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="1"
        layout="prev, pager, next, jumper"
        :total="pageTotalNum"></el-pagination>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" round size="mini" @click="innerVisible = true">添加字段</el-button>
      </el-col>
      <el-col :span="4">
        <el-button type="success" round size="mini" @click="handleUpdate">更新</el-button>
        <el-button type="default" round size="mini" @click="handleClose">取消</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <pdf v-if="ext_type == 'pdf'"
        :page="currentPage"
        :src="url"
        :rotate="pageRotate" 
        @progress="loadedRatio=$event"
        @num-pages="pageTotalNum=$event" 
        />
        <img v-else :src="url" alt="图片预览" width="50%">
      </el-col>
      <el-col :span="12">
        <el-form ref="form" :model="form" label-width="100px" style="margin-top: 50px;">
          <el-form-item v-for="(item, index) in active_label" :key="index" :label=item>
            <el-input type="textarea" autosize v-model="active_data[item]" style="width: 80%;"></el-input>
            <el-tooltip class="item" effect="dark" :content="`删除[${item}]`" placement="right">
              <el-button type="danger" icon="el-icon-remove" circle size="mini" @click="handleRemove(item)"></el-button>
            </el-tooltip>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-dialog
      width="30%"
      title="添加字段"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body>
      <table :border="1">
        <tr>
          <th>字段名称</th>
          <th>字段值</th>
        </tr>
        <tr>
          <td><el-input v-model="add_key" oninput="value = value.replace(/\s/g, '')"/></td>
          <td><el-input v-model.trim="add_val"/></td>
        </tr>
      </table>
      <el-button size="mini" type="success" style="float: right" @click="addField">确定</el-button>
    </el-dialog>
  </el-dialog>
</template>

<script>
import pdf from 'vue-pdf'
import { getCertData, updateCertData } from '@/api/cert'

export default {
  name: "common-form",
  components:{
    pdf
  },
  computed: {},
  data() {
    return {
      title: "船舶证书详情",
      dialogVisible: false,
      innerVisible: false,
      form: {},
      url: '',
      file_id: 0,
      ext_type: '',
      active_data: {},
      active_label: [],
      currentPage: 1,
      pageTotalNum: 1, // 文件总页数
      pageRotate: 0,
      loadedRatio: 0, // 当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成了
      add_key: '',
      add_val: '',
  }},
  methods: {
    updateActiveData() {
      this.active_data = this.form[this.currentPage]
      this.active_label = Object.keys(this.active_data)
    },
    handleOpen(file) {
      this.currentPage = 1
      this.title = file.name
      this.url = file.url
      this.file_id = file.id
      this.ext_type = file.ext_type
      if (file.ext_type !== 'pdf') {
        this.pageTotalNum = 1
      }

      getCertData({"file_id": file.id})
      .then(res => {
        if (Object.keys(res).length > 0) {
          this.form = res
          this.updateActiveData()
          this.dialogVisible = true
        }
        else {
          this.$error_message("该证书没有解析结果！")
        }
      })
      // this.test()
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      if (!this.form.hasOwnProperty(String(val))) {
        this.form[String(val)] = {}
      }
      this.updateActiveData()
    },
    handleRemove(key) {
      if (this.form[this.currentPage].hasOwnProperty(key)) {
        delete this.form[this.currentPage][key]
        this.updateActiveData()
      }
    },
    handleUpdate() {
      updateCertData({"file_id":this.file_id, "data":this.form})
      .then(res => {
        this.$message.success("保存完成")
        this.handleClose()
      })
    },
    addField() {
      let key = this.add_key.replace(/\s/g, '')
      if (this.form[this.currentPage].hasOwnProperty(key)) {
        this.$error_message("字段名称重复，不允许添加！")
        return
      }
      if (this.add_key==='' || this.add_val==='') {
        this.$error_message("传递参数不完整，请检查！")
        return
      }

      this.form[this.currentPage][key] =this.add_val
      this.updateActiveData()
      this.innerVisible = false
    },
    test() {
      this.form = {
        "1": {
          "船名": "1111",
          "呼号": "222",
          "船舶种类和等级": "333",
          "载重": "4444",
          "总长": "5555",
          "型宽": "666",
        },
        "2": {
          "船名": "1111",
          "呼号": "222",
          "曾用名": "333",
          "锚": "4444",
          "船籍": "5555",
          "船舶所有人": "5555",
          "其他": "红红火火恍恍惚惚",
          "船名1": "1111",
          "呼号1": "222",
          "曾用名1": "333",
          "锚1": "4444",
          "船籍1": "5555",
          "船舶所有人1": "5555",
          "其他1": "红红火火恍恍惚惚",
          "船名2": "1111",
          "呼号2": "222",
          "曾用名2": "333",
          "锚2": "4444",
          "船籍2": "5555",
          "船舶所有人2": "5555",
          "其他2": "红红火火恍恍惚惚",
          "船名3": "1111",
          "呼号3": "222",
          "曾用名3": "333",
          "锚3": "4444",
          "船籍3": "5555",
          "船舶所有3": "5555",
          "其他3": "红红火火恍恍惚惚"
        },
        "3": {},
        "4": {},
        "5": {},
        "6": {},
        "7": {},
        "8": {},
        "9": {},
        "10": {},
        "31": {},
      }
      this.updateActiveData()
    }
  },
  created() {}
}
</script>